import { render, staticRenderFns } from "./ShiftReportLocation.vue?vue&type=template&id=2754a349"
import script from "./ShiftReportLocation.vue?vue&type=script&lang=ts"
export * from "./ShiftReportLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports